/** @jsxImportSource @emotion/react */

import { Dialog } from "@bonusx-global/bx-design-system";
import { BellExclamationDuotone, SendOutlined } from "@bonusx-global/bx-icons";
import isFunction from "lodash/isFunction";
import isString from "lodash/isString";
import last from "lodash/last";
import { useNavigate } from "react-router-dom";
import { useDialogHandler } from "../../hooks/useDialogHandler";
import { useHeaderCloseButton } from "../../hooks/useHeaderCloseButton";
import { BonusXThemeProvider } from "../../theme/BonusXThemeProvider";

interface ConfirmExitFromServiceRequestProps {
  onConfirm?: () => void;
  onCancel?: () => void;
}

function ConfirmExitFromServiceRequest({ onConfirm, onCancel }: Readonly<ConfirmExitFromServiceRequestProps>) {
  const closeButton = useHeaderCloseButton();
  const { isOpen, closeDialog } = useDialogHandler();
  const navigate = useNavigate();

  function getCloseButtonUrl(...params: unknown[]): string | undefined {
    if (params.length <= 0) {
      return;
    }

    const filteredParams: string[] = params.filter(isString);

    return last(filteredParams);
  }

  function exitFromServiceRequestFromModal() {
    const closeUrl = getCloseButtonUrl(closeButton?.url, "/requested-services");

    isString(closeUrl) ? navigate(closeUrl) : navigate(-1);

    closeDialog();
  }

  function onClickCancel() {
    if (isFunction(onCancel)) {
      onCancel();
    }
    closeDialog();
  }

  function onClickSentToOperator() {
    if (isFunction(onConfirm)) {
      onConfirm();
    }
    exitFromServiceRequestFromModal();
  }

  return (
    <BonusXThemeProvider>
      <Dialog
        id="leave-request-dialog"
        open={isOpen}
        onClose={closeDialog}
        maxWidth="sm"
        title="Stai dimenticando qualcosa?"
        description="Se non hai altri documenti facoltativi da caricare, invia il turno all’operatore così che possa gestire la tua pratica."
        icon={<BellExclamationDuotone css={{ fontSize: 48 }} />}
        primaryButton={{
          children: "Invia all’operatore",
          color: "primary",
          endIcon: <SendOutlined />,
          id: "leave-request-dialog-primary-button-id",
          onClick: onClickSentToOperator,
          size: "medium",
          variant: "contained",
        }}
        secondaryButton={{
          children: "Esci dalla pratica",
          color: "primary",
          id: "leave-request-dialog-secondary-button-id",
          onClick: onClickCancel,
          size: "medium",
          variant: "outlined",
        }}
        onCloseButtonClick={closeDialog}
      />
    </BonusXThemeProvider>
  );
}

export default ConfirmExitFromServiceRequest;
